<template>
  <div>
    <Warehouses />
  </div>
</template>

<script>
import Warehouses from '@/nfmp_components/Warehouses.vue'
export default {
  components: {
    Warehouses
  }
}
</script>